<template>
  <MeetingsListLayout :loading="loading" :empty="appointments.length === 0" :groups="groupedAppointments">
    <template #toolbar>
      <h2 class="txt-headline-xl">{{ t('Meetings.declined.title') }}</h2>
      <SingleSelect v-model="selectedDay" :options="dayFilterOptions" :label="t('Meetings.myMeetings.filterByDay')" class="w-48" />
    </template>

    <template #empty>
      <img src="@/assets/images/meetings-list-placeholder.svg" alt="" class="mb-4 h-40" />
      <p class="text-body-m text-subtle">{{ t('Meetings.declined.noDeclined') }}</p>
    </template>

    <template #card="{ item }">
      <MeetingCard
        :ref="(el) => setCardRef(item.id, el)"
        :appointment="item as AppointmentNode"
        mode="declined"
        collapsible
        @save-notes="handleSaveNotes"
      />
    </template>
  </MeetingsListLayout>
</template>

<script setup lang="ts">
import { MeetingsListLayout } from '@ramp106/omrjs-events-ui'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { type AppointmentNode, useMeetingsDeclined } from '@/composables/meetings/useMeetingsDeclined'
import SingleSelect from '@/ui/SingleSelect.vue'

import MeetingCard from './components/MeetingCard.vue'

const { t } = useI18n()

const { selectedDay, loading, appointments, groupedAppointments, dayFilterOptions, saveExhibitorNotes } = useMeetingsDeclined()

// Card refs for resetting edit state
const cardRefs = ref<Record<string, InstanceType<typeof MeetingCard> | null>>({})

function setCardRef(id: string, el: unknown) {
  cardRefs.value[id] = el as InstanceType<typeof MeetingCard> | null
}

async function handleSaveNotes(appointmentId: string, notes: string) {
  const success = await saveExhibitorNotes(appointmentId, notes)
  cardRefs.value[appointmentId]?.resetEditingState(success)
}
</script>
